const e = "srna-event-system";
export {
  e as SIRONA_BROADCAST_CHANNEL
};
//# sourceMappingURL=crossTabEvents.js.map
